/**
 * Every brand-dependent value lives here.
 *
 * The defaults follow the Taco Bell system - one purple, used as an accent on
 * white rather than as a flood - but nothing in the components hard-codes a
 * colour or a logo, so another TacoBots application, or a rebrand, only has to
 * change these environment variables (specification section 38).
 */

const env = import.meta.env;

export interface Branding {
  appName: string;
  organisationName: string;
  logoUrl: string;
  faviconUrl: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  timezone: string;
}

export const branding: Branding = {
  appName: env.VITE_APP_NAME || 'TacoBots Forms',
  organisationName: env.VITE_ORG_NAME || 'Taco Bell Costa Rica',
  logoUrl: env.VITE_BRAND_LOGO_URL || '/brand/logo.svg',
  faviconUrl: env.VITE_BRAND_FAVICON_URL || '/brand/favicon.svg',
  primaryColor: env.VITE_BRAND_PRIMARY || '#5d2994',
  secondaryColor: env.VITE_BRAND_SECONDARY || '#9346d7',
  accentColor: env.VITE_BRAND_ACCENT || '#ffc300',
  timezone: env.VITE_DEFAULT_TIMEZONE || 'America/Costa_Rica',
};

/** Base URL of the API. Empty means same origin, which is the default. */
export const apiBaseUrl = (env.VITE_API_URL || '').replace(/\/+$/, '');
